import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-6323 — true when SSO is this deployment's only way in, so the auth
// screens drop the password form, the forgot-password link and the sign-up link
// and leave the SSO button on its own. The server already refuses those flows
// with `auth.require_sso_login_blocked`, so rendering them only invites a
// password that cannot work.
//
// Defaults to false while /app-config is still in flight, which keeps the form
// on screen for the one render a normal deployment needs it — hiding it
// optimistically would flash an empty card at every user on every sign-in.
export const usePasswordAuthDisabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isPasswordAuthDisabled ?? false;
};
